var _defs, _rect, _g, _rect2, _circle, _g2, _circle2, _rect3, _g3, _g4, _polygon, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _rect4, _rect5, _rect6, _rect7, _rect8, _polygon2, _circle3, _circle4, _circle5, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIlluUndrawSpreadsheets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "illu_undrawSpreadsheets",
    "data-name": "illu undrawSpreadsheets",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 908.72 593.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "9524657f-a5be-401f-9afa-21595579ad39",
    x1: 623.41,
    y1: 835.81,
    x2: 623.41,
    y2: 62.24,
    gradientTransform: "translate(1039.26 -172.82) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "48b6f8c1-7ad6-4b23-961c-36b9d10d8c20",
    x1: 600,
    y1: 746.58,
    x2: 600,
    y2: 153.42,
    gradientTransform: "translate(0.61 -0.81) rotate(0.08)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "spreadsheets") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 203.45,
    y: 183.42,
    width: 773.57,
    height: 534.35,
    transform: "translate(-146.25 -152.63) rotate(-0.08)",
    fill: "url(#9524657f-a5be-401f-9afa-21595579ad39)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 153.99,
    width: 908,
    height: 592.01,
    rx: 28.33,
    ry: 28.33,
    transform: "translate(-146.25 -152.61) rotate(-0.08)",
    fill: "url(#48b6f8c1-7ad6-4b23-961c-36b9d10d8c20)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 154.11,
    y: 158.92,
    width: 893.37,
    height: 581.1,
    rx: 28.33,
    ry: 28.33,
    transform: "translate(-146.24 -152.61) rotate(-0.08)",
    fill: "#535461"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 192.71,
    cy: 452.44,
    r: 20.68,
    transform: "translate(-146.25 -153.16) rotate(-0.08)",
    fill: "#535461"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 192.71,
    cy: 452.44,
    r: 20.68,
    transform: "translate(-146.25 -153.16) rotate(-0.08)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1011.51,
    cy: 363.1,
    r: 6.89,
    transform: "translate(-146.13 -152.06) rotate(-0.08)",
    fill: "#535461"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1008.86,
    y: 397.57,
    width: 6.89,
    height: 89.61,
    rx: 1.43,
    ry: 1.43,
    transform: "translate(-146.24 -152.06) rotate(-0.08)",
    fill: "#535461"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1008.86,
    y: 397.57,
    width: 6.89,
    height: 89.61,
    rx: 1.43,
    ry: 1.43,
    transform: "translate(-146.24 -152.06) rotate(-0.08)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1011.51,
    cy: 363.1,
    r: 6.89,
    transform: "translate(-146.13 -152.06) rotate(-0.08)"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "725 547.58 84.37 547.58 84.37 49.58 832.06 49.58 832.06 479.74 831.63 546.86 725 547.58",
    fill: "#fff"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.37,
    y: 221.97,
    width: 747.69,
    height: 6.86,
    fill: "#e0e0e0"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.37,
    y: 184.97,
    width: 747.69,
    height: 6.86,
    fill: "#e0e0e0"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.37,
    y: 147.97,
    width: 747.69,
    height: 6.86,
    fill: "#e0e0e0"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.37,
    y: 110.97,
    width: 747.69,
    height: 6.86,
    fill: "#e0e0e0"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.37,
    y: 73.97,
    width: 747.69,
    height: 6.86,
    fill: "#e0e0e0"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.37,
    y: 258.98,
    width: 747.69,
    height: 6.86,
    fill: "#e0e0e0"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.37,
    y: 296,
    width: 747.69,
    height: 6.86,
    fill: "#e0e0e0"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.37,
    y: 333.02,
    width: 747.69,
    height: 6.86,
    fill: "#e0e0e0"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.37,
    y: 370.04,
    width: 747.69,
    height: 6.86,
    fill: "#e0e0e0"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.37,
    y: 407.05,
    width: 747.69,
    height: 6.86,
    fill: "#e0e0e0"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.37,
    y: 444.07,
    width: 747.69,
    height: 6.86,
    fill: "#e0e0e0"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.36,
    y: 481.09,
    width: 747.57,
    height: 6.86,
    fill: "#e0e0e0"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.37,
    y: 518.11,
    width: 746.99,
    height: 6.86,
    fill: "#e0e0e0"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 174.16,
    y: 80.8,
    width: 5.18,
    height: 466.78,
    fill: "#e0e0e0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 288.56,
    y: 80.8,
    width: 5.18,
    height: 466.78,
    fill: "#e0e0e0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 402.96,
    y: 80.8,
    width: 5.18,
    height: 466.78,
    fill: "#e0e0e0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 517.36,
    y: 80.8,
    width: 5.18,
    height: 466.78,
    fill: "#e0e0e0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 631.76,
    y: 80.8,
    width: 5.18,
    height: 466.78,
    fill: "#e0e0e0"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "751.34 547.58 746.16 547.58 746.16 80.8 751.34 80.58 751.34 547.58",
    fill: "#e0e0e0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.09,
    cy: 61.08,
    r: 6.73,
    fill: "#ff5252"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.36,
    cy: 61.08,
    r: 6.73,
    fill: "#ff0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.63,
    cy: 61.08,
    r: 6.73,
    fill: "#69f0ae"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 293.36,
    y: 339.58,
    width: 110,
    height: 30,
    fill: "#4b55f6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 408.36,
    y: 487.58,
    width: 110,
    height: 30,
    fill: "#4b55f6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 522.36,
    y: 447.58,
    width: 110,
    height: 30,
    fill: "#4b55f6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 522.36,
    y: 228.58,
    width: 110,
    height: 30,
    fill: "#4b55f6"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 637.36,
    y: 376.58,
    width: 110,
    height: 30,
    fill: "#4b55f6"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 178.36,
    y: 117.58,
    width: 110,
    height: 30,
    fill: "#4b55f6"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 408.36,
    y: 192.58,
    width: 110,
    height: 30,
    fill: "#4b55f6"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 178.36,
    y: 265.58,
    width: 110,
    height: 30,
    fill: "#4b55f6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlluUndrawSpreadsheets);
export default __webpack_public_path__ + "static/media/illu_undrawSpreadsheets.c6ae92b3c6aab85f9e6e4e9cb1e62040.svg";
export { ForwardRef as ReactComponent };